import { DemoIndicatorColoredIcon } from '@carboncopyco/icons';
import type { DemoOverlay } from '@carboncopyco/types';
import { TooltipBubble } from '@carboncopyco/ui';
import { useCallback } from 'react';
import { SearchResultTile } from '../../../GridTiles';
import { useWorkspacePageProps } from '../WorkspacePageContext';
import { OverlayActionsDropdown } from './EntitiesActionsDropdown/OverlayActionsDropdown';

export const OverlaySearchResultTile = ({
  demo,
  archived,
  inFolder,
}: {
  demo: DemoOverlay;
  archived?: boolean;
  inFolder?: boolean;
}) => {
  const { goToDemo, workspaceId } = useWorkspacePageProps();
  const { id, demoName, image, totalPresentations, updateTime } = demo;

  const DropdownAction = useCallback(
    ({ toggleMenu }) => {
      return (
        <OverlayActionsDropdown
          archived={archived}
          handleMenuOpen={toggleMenu}
          demo={demo}
          inFolder={inFolder}
        />
      );
    },
    [demo, archived, inFolder]
  );

  return (
    <SearchResultTile
      lastUpdated={updateTime}
      title={demoName || 'Missing title'}
      image={image}
      isOverlayDemo
      totalPresentations={totalPresentations}
      onTileClick={
        archived ? undefined : () => goToDemo(String(id), workspaceId)
      }
      ActionDropdown={DropdownAction}
      icon={
        <TooltipBubble
          placement="top"
          title="Demo (live app)"
        >
          <DemoIndicatorColoredIcon size={18} />
        </TooltipBubble>
      }
    />
  );
};
